import { Box, styled } from "@mui/material";

const LightningLandersCodeEditorContainer = styled(Box)<{ visible }>(
  ({ theme, visible }) => ({
    opacity: visible ? 1 : 0,
    height: visible ? "calc(100% - 48px)" : 0, // adjust for your Tabs height
    padding: theme.spacing(2),
    overflow: "auto",
    width: "100%!important",
    "& .code-panel": {
      height: "100%",
      display: "flex!important",
      flexDirection: "column",
      "& section": {
        height: "100%!important",
      },
      "& .codepanel-separator": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
      },
      "& .codepanel-label": {
        ...theme.typography.subtitle2,
      },
      "& .gjs-btn-prim": {
        background: theme.palette.primary.main,
        borderRadius: theme.shape.borderRadius,
        color: "white",
      },
      "& .gutter": {
        height: 2,
        borderTop: `1px solid rgba(104, 106, 168, 0.2)`,
        borderBottom: `1px solid rgba(255,255,255,0.7)`,
        margin: theme.spacing(4, 0, 3, 0),
      },
      "& .CodeMirror": { height: "100%" },
      "& .cp-delete-css": {
        display: "none",
      },
    },
  })
);

export default LightningLandersCodeEditorContainer;
